import { Link } from 'react-router-dom';

const mapTypeToLabel = t => {
    if (String(t).toLowerCase() === 'checkin') return 'Move In';
    if (String(t).toLowerCase() === 'checkout') return 'Move Out';
    if (String(t).toLowerCase() === 'periodic') return 'Periodic';
    return 'Unknown';
};

export const InventoryTile = ({ inventory, tenantId }) => {

    const getPhotoPath = inv => {
        if (!inv || !inv.photos || !inv.photos.length) return null;
        // Find the first photo that has a usable preview/url
        const p = inv.photos.find(ph => ph && (ph.thumbPathIncSASToken || ph.pathIncSASToken || ph.thumbPathIncludingSasToken || ph.pathIncludingSasToken || ph.thumbPath || ph.path || ph.url || ph.dataUrl));
        if (!p) return null;
        // Try all known variants used in the codebase
        return p.thumbPathIncSASToken || p.pathIncSASToken || p.thumbPathIncludingSasToken || p.pathIncludingSasToken || p.thumbPath || p.path || p.url || p.dataUrl || null;
    };


    const imageNotAvailableClass = (inv) => {
        const result = 'property product' + (getPhotoPath(inv) ? '' : ' not-available');
        return result;
    };

    const imageStyle = (inv) => {
        const unknown = { marginTop: '20px', alignSelf: 'center', maxHeight: '180px', width: '50%', backgroundImage: 'url(/assets/img/pos/unknown-user.png)' };
        const known = { backgroundImage: `url(${getPhotoPath(inv)})` };
        return getPhotoPath(inv) ? known : unknown;
    };

    const productStyle = {
        background: 'var(--app-component-bg)',
        color: 'var(--app-component-color)',
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        textDecoration: 'none',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '8px',
        transition: 'all .2s linear',
    };

    const imgStyleInline = Object.assign({}, imageStyle(inventory), { backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', minHeight: 180 });

    const textStyleInline = { flex: 1, display: 'flex', flexDirection: 'column', padding: '0.75rem 1rem' };

    return (
        <div key={`inventory-${inventory && inventory.id}`} className="product-container" >
            <Link to={`/tenant/detail/${tenantId || (inventory && inventory.tenantId)}/inventory/${inventory && inventory.id}`} className={imageNotAvailableClass(inventory) + ' product'} style={productStyle}>
                <div className="img mt-10px" style={imgStyleInline}></div>
                <div className="text" style={textStyleInline}>
                    <div className="property-description mt-auto">{mapTypeToLabel(inventory && inventory.type)}</div>
                    <div className="property-description mt-auto">{inventory && inventory.date ? new Date(inventory.date).toLocaleDateString() : ''}</div>
                    {/* Main notes shown below the date. Clamp to 2 lines for tile layout; use muted, lighter grey and italic */}
                    <div className="property-description mt-1 text-black-100 fst-italic" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>{inventory && inventory.notes}</div>
                    <div className="property-description mt-auto">Photos: {(inventory && inventory.photos) ? inventory.photos.length : 0}</div>
                </div>
                {!getPhotoPath(inventory) && (
                    <div className="not-available-text">
                        <div>Image Not Available</div>
                    </div>
                )}
            </Link>
        </div>
    );
};

export default InventoryTile;
